// extracted by mini-css-extract-plugin
module.exports = {"page":"_V","pdp":"aW","cart":"bW","brand":"cW","cartModal":"dW","checkout":"eW"};